export const mugshotSrc = (player) => {
    return ("./images/mugshots/" +
        `${player.firstname}${player.lastname}`.replace(/[^a-zA-Z]/gi, "") +
        ".png");
};
